module.exports = __webpack_public_path__ + "img/impact@2x.fe50f092.webp";